// Builds the visible inbox triage groups (duration / project / context).
import { formatHours } from '@/components/ui/formatHours';
import {
  getDurationTriageTasks,
  getUntaggedProjectTasks,
  getUntaggedContextTasks,
  buildProjectDropZones,
  buildContextDropZones,
  buildDurationZoneLabels,
} from '@/features/organize/utils/inboxTriageUtils';

export function buildInboxTriageGroups({
  t,
  durationTasks,
  projectTasks,
  contextTasks,
  durationCount,
  projectCount,
  contextCount,
  projectDisplayMap,
  contextDisplayMap,
}) {
  return [
    {
      key: 'duration',
      label: t('inboxview.duration', 'Standaardduur'),
      count: durationCount,
      tasks: durationTasks,
      listId: 'inbox-panel-duration',
      zones: buildDurationZoneLabels(t, formatHours),
    },
    {
      key: 'project',
      label: t('inboxview.missingProject', 'Geen project'),
      count: projectCount,
      tasks: projectTasks,
      listId: 'inbox-panel-project',
      zones: buildProjectDropZones(projectDisplayMap),
    },
    {
      key: 'context',
      label: t('inboxview.missingContext', 'Geen context'),
      count: contextCount,
      tasks: contextTasks,
      listId: 'inbox-panel-context',
      zones: buildContextDropZones(contextDisplayMap),
    },
  ].filter((g) => g.count > 0);
}

export {
  getDurationTriageTasks,
  getUntaggedProjectTasks,
  getUntaggedContextTasks,
};
